import React from 'react';
import styles from './CategorySelector.module.scss';
import { Category } from '../../../types/projectDocumentation';
import CheckIcon from '../../../assets/iconsTsx/CheckIcon.tsx';

interface CategorySelectorProps {
  categories: Category[];
  selectedCategory: string | null;
  onSelect: (categoryId: string) => void;
}

const CategorySelector: React.FC<CategorySelectorProps> = ({
  categories,
  selectedCategory,
  onSelect
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Selecciona una categoría</h2>
        <p className={styles.description}>
          Elige la categoría que mejor describa tu anteproyecto
        </p>
      </div>

      <div className={styles.categoriesGrid}>
        {categories.map((category) => (
          <div
            key={category.id}
            className={`${styles.categoryCard} ${
              selectedCategory === category.id ? styles.selected : ''
            }`}
            onClick={() => onSelect(category.id)}
          >
            <div className={styles.categoryIcon}>
              <div className={styles.iconPlaceholder}>
                {category.name.charAt(0).toUpperCase()}
              </div>
            </div>
            <h3 className={styles.categoryName}>{category.name}</h3>
            {selectedCategory === category.id && (
              <div className={styles.checkmark}>
                <CheckIcon className={styles.checkIcon} />
              </div>
            )}
          </div>
        ))}
      </div>

      {categories.length === 0 && (
        <div className={styles.emptyState}>
          <p>No hay categorías disponibles</p>
        </div>
      )}
    </div>
  );
};

export default CategorySelector;
